import connect from './connect'
import EditShirtModal from './EditShirtModal'

export default connect(EditShirtModal)
